import React, { useEffect, useState } from "react";
import "../../Pages/CleeQ.css";
import "../../Pages/Responsive.css";
import { makeStyles } from "@material-ui/core/styles";
import OurLanding from "./OurLanding";
import Aos from "aos";
import "aos/dist/aos.css";
import ContactUs from "../ContactUs";
import PresidentSpeech from "../PresidentSpeech";
import "../../Components/NavBar/NavBar.css";
import NavBar from "../../Components/NavBar/NavBar";
import SocialHeadings from "../../Components/SocialHeadings";
import image1 from "../../asset/images/image1.jpg";
import image2 from "../../asset/images/image2.jpg";
import image3 from "../../asset/images/image3.jpg";
import DemoBtn from "../../Components/DemoBtn";
import EventProperties from "../Events/EventProperties";

const images = [image1, image2, image3];

// const NavBar = () => {
//   return (
//     <div className="container NavBarContainer p-0">
//       <div>
//         <SoleraLogo />
//       </div>
//       <div>
//       <NavBarList/>
//       </div>

//       <div className="SignUpAndLoginContianer22">
//         <SignUpAndLogin />
//       </div>
//     </div>
//   );
// };

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

function CleeQ() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  // useEffect(() => {
  //   Aos.init({ duration: 1000 });
  //   window.scrollTo(0, 0);
  // }, []);
  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.scrollTo(0, 0);

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const classes = useStyles();

  return (
    <div>
      <header className="SoleraSticky">
        <div className="SocialHeadings-Display">
          <SocialHeadings />
        </div>

        <NavBar />
      </header>
      <div className="landing-page">
        <div
          className="background-image"
          style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
        >
          <div className="overlay"></div>
        </div>
        <div className="container p-0 content-Container">
          <div className="LandingContainer">
            <div className="LandingCoverUp">
              <div className="LandingHedings4030" data-aos="zoom-in-up">
                Welcome to <br />
                <span className="LandingHedings40301">
                  University of Lagos{" "}
                </span>
                <br />
                ALUMNI UK
              </div>

              <p className="SoleraIntro4030">
                The networking hub is the gathering spot for graduates from
                Akoka and Idi-Araba. You are welcome to join and be part our
                prestigious community working together in partnership with the
                University of Lagos to add value, contribute and make
                improvements to the community and our students.
              </p>
            </div>
            <div className="DemoRequest">
              <DemoBtn />
            </div>
          </div>
        </div>
      </div>
      <div id="">
        <PresidentSpeech />
      </div>
     <div className="container  p-0 VissionC">
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="VisonCont-Wrapper">
              <div>
                <div className="LandingHedings10" data-aos="zoom-in-up">
                  Our Vision
                </div>
                <p className="SoleraIntro14">
                  To establish a vibrant and inclusive network for the
                  University of Lagos graduates 
                  residing in the UK, fostering the exchange of knowledge,
                  ideas, and experiences to  empower and strengthen the
                  alumni community.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="VisonCont-Wrapper">
              <div>
                {" "}
                <div className="LandingHedings10" data-aos="zoom-in-up">
                  Our Mission
                </div>
                <p className="SoleraIntro14">
                  To establish a lasting heritage that honors our
                  accomplishments, safeguards our 
                  traditions, and prepare the path for generations to come.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="VisonCont-Wrapper">
              <div>
                <div className="LandingHedings10" data-aos="zoom-in-up">
                  Our Goals
                </div>

                <p className="SoleraIntro14">
                  Our team members share core values that are rooted in:
                  <br />
                  1. To provide support and empowerment to the next generation
                  of alumni <br />
                  2. To transform the alumni community into a wellspring of
                  inspiration for  emerging leaders and young individuals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /> <br /> <br />
      <div id="">
        <EventProperties />
      </div>
      <div id="">
        <ContactUs />
      </div>
    </div>
    // <div>
    //   <header className="SoleraSticky">
    //     <div className="SocialHeadings-Display">
    //       <SocialHeadings />
    //     </div>

    //     <NavBar />
    //   </header>

    //   <div id="Home">
    //     <OurLanding />
    //   </div>

    //   <div id="">
    //     <PresidentSpeech />
    //   </div>

    //   <div id="Photo Gallery">
    //     <ContactUs />
    //   </div>
    // </div>
  );
}

export default CleeQ;
